module.exports = __webpack_public_path__ + "img/17a001-12.8891f10c.png";